import React, {useEffect, useState} from "react";
import {api} from "../utils/gashtaltAPI";
import Loader from "../components/Loader";
import ErrorPage from "../components/ErrorPage";
import Navbar from "../components/Navbar";
import {Table, TableContainer, Tbody, Td, Thead, Tr} from "@chakra-ui/react";
import {toPersianNumber} from "../utils/numberConversion";
import {useNavigate} from "react-router-dom";

function Results() {
    const [exams, setExams] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [loading,setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/exam/results')
                setExams(response.data.data);

            } catch (error) {
                setError(error)
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);

    if (loading) return <Loader />
    if (error) return <ErrorPage error={error}/>;
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="table-container flex-fill d-flex flex-column justify-content-between"
                 style={{borderTop: '3px solid #EAEAEA'}}>
                <TableContainer>
                    <Table variant='striped' colorScheme='teal'>
                        <Thead>
                            <Tr>
                                <Td>ردیف</Td>
                                <Td>آزمون</Td>
                                <Td>کارنامه</Td>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {exams.map((exam, index) => exam === null ? null : (
                                <Tr>
                                    <Td>{toPersianNumber(index + 1)}</Td>
                                    <Td>{exam.name}</Td>
                                    <Td>
                                        <button
                                            className={`btn btn-outline-green`}
                                            onClick={() => {
                                                navigate(`/Result/${exam.id}`)
                                            }}>
                                            نمایش
                                        </button>
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>
            <div>

            </div>
        </div>
    );
}

export default Results;